import * as React from 'react';
import PropTypes from 'prop-types';

const ClientContext = React.createContext();

function ClientProvider({ client, children }) {
  return <ClientContext.Provider value={client}>{children}</ClientContext.Provider>;
}

function useClient() {
  const context = React.useContext(ClientContext);
  if (context === undefined) {
    throw new Error('useClient must be used within a ClientProvider');
  }
  return context;
}

ClientProvider.propTypes = {
  // eslint-disable-next-line
  client: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default ClientProvider;
export { useClient };
